export const skills = {
  data: [
    {
      title: 'Full Stack Web Development',
      fileName: 'FullStackImg',
      skills: [
        '⚡ Building resposive front end website using React.js - Redux',
        '⚡ Creating website application backend in Node, Express & MongoDB',
      ],
      softwareSkills: [
        {
          skillName: 'HTML5',
          fontAwesomeClassname: 'simple-icons:html5',
          style: {
            color: '#E34F26',
          },
        },
        {
          skillName: 'CSS3',
          fontAwesomeClassname: 'fa-css3',
          style: {
            color: '#1572B6',
          },
        },
        {
          skillName: 'Sass',
          fontAwesomeClassname: 'simple-icons:sass',
          style: {
            color: '#CC6699',
          },
        },
        {
          skillName: 'JavaScript',
          fontAwesomeClassname: 'simple-icons:javascript',
          style: {
            backgroundColor: '#000000',
            color: '#F7DF1E',
          },
        },
        {
          skillName: 'Git',
          fontAwesomeClassname: 'logos:git',
          style: {
            color: '#000000',
          },
        },
        {
          skillName: 'ReactJS',
          fontAwesomeClassname: 'simple-icons:react',
          style: {
            color: '#61DAFB',
          },
        },
        {
          skillName: 'NodeJS',
          fontAwesomeClassname: 'simple-icons:node-dot-js',
          style: {
            color: '#339933',
          },
        },
        {
          skillName: 'NPM',
          fontAwesomeClassname: 'simple-icons:npm',
          style: {
            color: '#CB3837',
          },
        },
        {
          skillName: 'MongoDB',
          fontAwesomeClassname: 'simple-icons:mongodb',
          style: {
            color: 'green',
          },
        },
        {
          skillName: 'Yarn',
          fontAwesomeClassname: 'simple-icons:yarn',
          style: {
            color: '#2C8EBB',
          },
        },
      ],
    },
  ],
};
